import React from "react";
import { CommandBarButton, IconButton, Stack } from "@fluentui/react";
import DetailsTable from "../../../Table/DetailsTable";
import FeatureSummary from "../../../Util/FeatureSummary";

const ChecklistTable = ({
  checklists,
  setSelectedChecklistId,
  setSelectedChecklistName,
  selectedChecklistId,
  cloneOnClick,
  onOffSettingsOnClick,
  loading,
  deleteOnClick,
  editOnClick,
  createOnClick,
  editActionItems,
  previewOnClick,
}) => {
  const columns = [
    {
      key: "column1",
      name: "ID",
      fieldName: "checklistID",
      minWidth: 30,
      maxWidth: 30,
      isResizable: true,
    },
    {
      key: "column2",
      name: "Checklist Name",
      fieldName: "name",
      minWidth: 200,
      maxWidth: 420,
      isResizable: true,
      onRender: (item) => (
        <Stack
          horizontal
          horizontalAlign="space-between"
          verticalAlign="center"
          styles={{ root: { width: "100%" } }}
        >
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              minWidth: 0,
              flex: 1,
            }}
            title={item.name}
          >
            {item.name}
          </span>
          <ContextualMenu
            editOnClick={editOnClick}
            cloneOnClick={cloneOnClick}
            deleteOnClick={deleteOnClick}
            onOffSettingsOnClick={onOffSettingsOnClick}
            previewOnClick={previewOnClick}
            editActionItems={editActionItems}
            id={item.checklistID}
            name={item.name}
            status={item.status}
            isActive={item.active === "Active"}
          />
        </Stack>
      ),
    },
    {
      key: "column3",
      name: "Status",
      fieldName: "status",
      minWidth: 120,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "columnActive",
      name: "Active",
      fieldName: "active",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column4",
      name: "Primary Cobrands",
      fieldName: "primaryCobrands",
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "column5",
      name: "Created Date",
      fieldName: "createdDate",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "column7",
      name: "Last Updated On",
      fieldName: "lastUpdatedOn",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
    },
  ];

  const items = checklists
    ? checklists.map((checklist) => ({
        checklistID: checklist.checklistID,
        name: checklist.name,
        status: checklist.status,
        active: checklist.isActive ? "Active" : "Inactive",
        primaryCobrands:
          checklist.primaryCobrands && checklist.primaryCobrands.join(", "),
        createdDate: checklist.createdDate,
        lastUpdatedOn: checklist.lastUpdatedOn,
      }))
    : [];

  const selectionHook = (items) => {
    setSelectedChecklistId(items && items[0] && items[0].checklistID);
    setSelectedChecklistName(items && items[0] && items[0].name);
  };

  return (
    <>
      <DetailsTable
        items={items}
        columns={columns}
        selectionMode="none"
        selectionHook={selectionHook}
        loading={loading}
        mainColumn={"name"}
        style={{
          position: "relative",
          height: "80vh",
          width: "80vw",
        }}
        CommandBar={
          <>
            <CommandBarButton
              iconProps={{ iconName: "Add" }}
              text="Add Checklist"
              onClick={() => createOnClick()}
            />
          </>
        }
      />
      <FeatureSummary
        label="About Checklists"
        summary="This table displays all checklists, including their name, status, associated cobrands, and creation date. You can add, edit, clone, or delete checklists. Checklists are used to organize and track user tasks and progress. If on for a cobrand, you will usually find them at '/list/<checklist-slug>'. Note: Inactive checklists cannot be edited or have their action items viewed. To make changes, reactivate the checklist first."
        imageUrlPath='checklist-summary'
      />
    </>
  );
};

const moreIcon = { iconName: "More" };

const ContextualMenu = ({
  editOnClick,
  cloneOnClick,
  deleteOnClick,
  onOffSettingsOnClick,
  previewOnClick,
  editActionItems,
  id,
  name,
  status,
  isActive,
  ...rest
}) => {
  const allItems = [
    isActive && {
      key: "print",
      iconProps: { iconName: "Edit" },
      text: "Edit",
      onClick: () => editOnClick(id),
    },
    {
      key: "Delete",
      iconProps: { iconName: "Delete" },
      text: "Delete",
      onClick: () => deleteOnClick(id, name, status),
    },
    {
      key: "Clone",
      iconProps: { iconName: "Copy" },
      text: "Clone",
      onClick: () => cloneOnClick(id),
    },
    {
      key: "On Off Settings",
      iconProps: { iconName: "SeeDo" },
      text: "On Off Settings",
      onClick: () => onOffSettingsOnClick(id),
    },
    isActive && {
      key: "Preview Checklist",
      iconProps: { iconName: "RedEye" },
      text: "Preview Checklist",
      onClick: () => previewOnClick(id),
    },
    isActive && {
      key: "Edit Action Items",
      iconProps: { iconName: "PageHeaderEdit" },
      text: "Edit Action Items",
      onClick: () => editActionItems(id),
    },
  ].filter(Boolean);

  const menuProps = {
    items: allItems,
  };

  return (
    <IconButton
      iconProps={moreIcon}
      menuProps={menuProps}
      onRenderMenuIcon={() => {}}
      {...rest}
    />
  );
};

export default ChecklistTable;
